import axios from "../utils/axios";

export const removeTechnicianPlannedMaintenance = ({ taskId, userCode }) => {
    return axios.post(`/PlannedMaintenance/RemoveTechnician?taskId=${taskId}&userCode=${userCode}`);
};

export const removeTechnicianUnplannedMaintenance = ({ taskId, userCode }) => {
    return axios.post(`/UnplannedMaintenance/RemoveTechnician?taskId=${taskId}&userCode=${userCode}`);
};
